import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import ParseHTML from 'components/atoms/ParseHTML';

// Utils
import { clickEvent } from 'utils/adaConfigurations/customEvents';

import './DataSlot.scss';
const ns = 'data-slot';

const DataSlot = ({
  value,
  onClick,
  className,
  active,
  disabled,
  hasPromotion,
  dataSlotAriaLabel
}) => {
  const classProps = cn(ns, className, {
    [`${ns}--active`]: active,
    [`${ns}--disabled`]: disabled,
    [`${ns}--promotion`]: hasPromotion
  });
  return (
    <div
      tabIndex={0}
      aria-label={dataSlotAriaLabel || ''}
      className={classProps}
      onClick={() => !disabled && onClick()}
      onKeyUp={e => {
        !disabled && clickEvent(e);
      }}
    >
      <ParseHTML html={value} />
    </div>
  );
};

DataSlot.propTypes = {
  /** Boolean indicating whether the slot has been selected */
  active: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  hasPromotion: PropTypes.bool,
  onClick: PropTypes.func,
  value: PropTypes.string,
  dataSlotAriaLabel: PropTypes.string
};

DataSlot.defaultProps = {
  active: false,
  onClick: () => {},
  disabled: false
};

export { ns };
export default DataSlot;



// WEBPACK FOOTER //
// ./src/components/atoms/DataSlot/DataSlot.js